import { IStripeCouponWrapper, ISubscriptionPaymentSummary } from 'fitbeat.models';
import moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { capitalize, defaultScale, isWeb } from '../../utils';
import getMomentFormat from '../../utils/LocaleMoment';
import { getPerIntervalProRatedBilling } from './PaymentSummaryDisplay';
import { styles } from './SubscriptionSummary';

interface IProps {
  t: (key: string, options?: any) => string;
  total: number;
  paymentSubscriptionSummary: ISubscriptionPaymentSummary;
  hideHeading?: boolean;
  showingExistingSubscription?: boolean;
}

class TrialSubscriptionSummary extends PureComponent<IProps> {

  public couponAmountOff = (coupon: IStripeCouponWrapper, currencySymbol: string): string => {
    const { t } = this.props;
    if (coupon.percent_off) {
      return `${coupon.percent_off.toFixed(0)}% ${t('discountApplied')}: ${coupon.id}`;
    }
    if (coupon.amount_off) {
      return `${currencySymbol}${coupon.amount_off / 100} ${t('discountApplied')}: ${coupon.id}`;
    }
    return '';
  };

  public render() {
    const { t, paymentSubscriptionSummary, total, showingExistingSubscription, hideHeading } = this.props;
    const trialEndDate = paymentSubscriptionSummary.trialEndTimestamp &&
      paymentSubscriptionSummary.trialEndTimestamp * 1000;
    const subscriptionStartDate = trialEndDate && getMomentFormat(trialEndDate, 'D MMMM', moment.tz.guess());
    const displayInterval = getPerIntervalProRatedBilling(t, paymentSubscriptionSummary.interval);

    return (
      <>
        {isWeb() && !showingExistingSubscription && !hideHeading &&
          <View style={styles.headingContainer}>
            <Text style={styles.heading}>
              {paymentSubscriptionSummary.paymentMethodRequired ?
                t('paymentScreenHeaderCardRequiredPart1') : t('pressContinueTo')}
            </Text>
            <Text style={styles.headingBold}>
              {t('activateYourFreeTrial', { days: paymentSubscriptionSummary.trialPeriodDays })}
            </Text>
          </View>
        }

        <View style={[styles.row,
          !showingExistingSubscription && { borderTopWidth: 0 },
          showingExistingSubscription && { marginTop: defaultScale(20) },
        ]}>
          <View style={styles.rowTextContainer}>
            <Text style={styles.boldReg}>{paymentSubscriptionSummary.planTrialDescription}</Text>
            {!showingExistingSubscription &&
              <Text style={styles.lightText}>{t('cancelAnytimePaywall')}</Text>
            }
          </View>
          <View style={styles.rowValueContainer}>
            <Text style={styles.boldReg}>{paymentSubscriptionSummary.currencySymbol}0</Text>
          </View>
        </View>

        {!paymentSubscriptionSummary.cancelsAtPeriodEnd &&
          <>
            {showingExistingSubscription &&
              <>
                <View style={styles.row}>
                  <View style={styles.rowTextContainer}>
                    <Text style={styles.boldReg}>{t('intervalMembership', {
                      interval: capitalize(displayInterval)})}</Text>
                    {subscriptionStartDate &&
                      <Text style={styles.boldReg}>
                        {t('subscriptionStarts', { startDate: subscriptionStartDate })}
                      </Text>
                    }
                  </View>
                  <View style={styles.rowValueContainer}>
                    <Text style={styles.boldReg}>
                      {paymentSubscriptionSummary.subscriptionDisplayTotalAfterDiscounts}
                    </Text>
                    <Text style={styles.lightText}>
                      {getPerIntervalProRatedBilling(t, paymentSubscriptionSummary.interval)}
                    </Text>
                  </View>
                </View>
                <View style={localStyle.fullWidthSection}>
                  <Text style={styles.lightText}>
                    {t('inTrialSubscriptionSummary')}
                  </Text>
                  {paymentSubscriptionSummary.coupon &&
                    <Text style={[styles.lightText, { marginTop: defaultScale(15) }]}>
                      {this.couponAmountOff(
                        paymentSubscriptionSummary.coupon, paymentSubscriptionSummary.currencySymbol)}
                    </Text>
                  }
                </View>
              </>
            }

            {!showingExistingSubscription &&
              <>
                <View style={styles.row}>
                  <View style={styles.rowTextContainer}>
                    <Text style={styles.boldReg}>{t('membershipAfterFreeTrial', {
                      interval: capitalize(displayInterval),
                    })}</Text>
                    <Text style={styles.lightText}>
                      {t('afterTrialEnds', {
                        interval: displayInterval,
                        subscriptionTotal: paymentSubscriptionSummary.subscriptionDisplayTotalAfterDiscounts,
                      })}
                    </Text>

                    {paymentSubscriptionSummary.coupon &&
                      <Text style={[styles.lightText, { marginTop: defaultScale(15) }]}>
                        {this.couponAmountOff(paymentSubscriptionSummary.coupon,
                          paymentSubscriptionSummary.currencySymbol)}
                      </Text>
                    }
                  </View>
                  <View style={styles.rowValueContainer}>
                  </View>
                </View>
              </>
            }
          </>
        }

        <View style={styles.row}>
          <View style={styles.rowTextContainer}>
            <Text style={styles.totalText}>{showingExistingSubscription ? t('total') : t('totalDueToday')}</Text>
          </View>
          <View style={styles.rowValueContainer}>
            <Text style={styles.totalText}>{paymentSubscriptionSummary.currencySymbol}0</Text>
          </View>
        </View>
      </>
    );
  }
}

const localStyle = StyleSheet.create({
  fullWidthSection: {
    paddingBottom: defaultScale(18),
  },
});

export default TrialSubscriptionSummary;
